import React from "react";
import carLoader_en from "../../../assets/images/car_en.gif";
import travelLoader_en from "../../../assets/images/travel_en.gif";
import carLoader_ar from "../../../assets/images/car_ar.gif";
import travelLoader_ar from "../../../assets/images/travel_ar.gif";
import Logo_gif from "../../../assets/images/logo.gif";
import i18next from "i18next";

import "./style.css";

export const Loader = ({ type, classList = "" }) => {
  const currentLanguage = i18next.language;
  switch (type) {
    case "car":
      return (
        <div className="car-loader">
          <img
            src={currentLanguage === "ar" ? carLoader_ar : carLoader_en}
            alt="Loading..."
            className="cargif"
          />
        </div>
      );
    case "airplane":
      return (
        <div className="car-loader">
          <img
            src={currentLanguage === "ar" ? travelLoader_ar : travelLoader_en}
            alt="Loading..."
            className="cargif"
          />
        </div>
      );
    case "logo-gif":
      return (
        <div className={`rl-loading-container ${classList}`}>
          <img src={Logo_gif} alt="loader" className="img-fluid" />
        </div>
      );

    default:
      return (
        <div className="rl-loading-container">
          <div className="rl-loading-thumb rl-loading-thumb-1"></div>
          <div className="rl-loading-thumb rl-loading-thumb-2"></div>
          <div className="rl-loading-thumb rl-loading-thumb-3"></div>
        </div>
      );
  }
};
